<template>
  <div class="warehousing-detail">
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      label-position="right"
      :show-message="false"
    >
      <el-collapse :value="collapse">
        <!--工作号信息-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.JobNumberInformation') }}</span>
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="100px"
              label-position="right"
              :disabled="true"
              style="margin-right:10px"
            >
              <el-form
                :disabled="true"
                class="section"
                style="flex-direction: row;width:90%;min-width:1200px"
              >
                <span style="display: flex;align-items: center;width: 64px">
                  {{ $t('FbaJob.ValueAddedServices') }}
                </span>
                <el-checkbox-group v-model="selectedLocalAddedService">
                  <el-checkbox
                    v-for="item in localAddedService"
                    :key="item.code"
                    :label="item.code"
                    style="margin-left: 8px;margin-right: 8px"
                  >
                    {{ item.chineseName }}
                  </el-checkbox>
                  <el-checkbox v-model="form.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
                </el-checkbox-group>
              </el-form>
              <el-row>
                <el-col :span="4.8">
                  <!-- 业务编号-->
                  <el-form-item :label="$t('SeaExport.BusinessNo')" prop="jobNo">
                    <el-input v-model="form.jobNo" no="jobNo" />
                  </el-form-item>
                  <!-- 亚马逊仓库编码-->
                  <el-form-item :label="$t('CargoMsg.Cargo_Destination')" prop="warehouseCode">
                    <div style="display: flex;">
                      <el-tooltip :content="form.warehouseCode" placement="bottom-end">
                        <el-cascader
                          v-model="form.warehouseCode"
                          no="warehouseCode"
                          style="width: 91px; padding-right: 2px;"
                          :options="destinations"
                          filterable
                          :clearable="true"
                          @focus="JobUtils.focusWarehouseCode(form)"
                          @blur="JobUtils.blurWarehouseCode(form)"
                          @change="p=>{JobUtils.warehouseCodeHandler(form, p);}"
                        />
                      </el-tooltip>
                      <el-checkbox v-model="form.remoteWarehouse" no="remoteWarehouse">{{
                        $t('Warehouse.RemoteWarehouse')
                      }}
                      </el-checkbox>
                    </div>
                  </el-form-item>
                  <!-- 国外仓-->
                  <el-form-item :label="$t('SeaExport.OverseasWarehouse')">
                    <cargo-advance-select
                      no="overseaWarehouseCode"
                      :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                      filterable
                      :method-params="{ifFba:false}"
                      :clearable="false"
                      tag-name="countryChineseName"
                      tag-value="warehouseCode"
                      :default-value="form.overseaWarehouseCode"
                      style="width:100%;"
                      @parentCallBack="p=>{form.overseaWarehouseCode=p.value}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <!-- 委托单位-->
                  <el-form-item :label="$t('SeaExport.ConsignationCompany')" prop="customerId">
                    <cargo-company-select
                      no="customerId"
                      class="shipper-selector"
                      popper-class="shipper-selector-popper"
                      :method-params="{customer:true, active:true}"
                      :check-credit="true"
                      :job="form"
                      :default-value="form.customerId||''"
                      style="flex: 1;"
                    />
                  </el-form-item>
                  <!-- 目的国-->
                  <el-form-item :label="$t('Warehouse.DestinationCountry')" prop="destinationCountry">
                    <el-input v-model="form.country" no="destinationCountry" />
                  </el-form-item>
                  <!-- 计费方式-->
                  <el-form-item :label="$t('FbaJob.ChargingMethod')">
                    <el-radio-group v-model="form.chargingMethod">
                      <el-radio :label="'0'">{{ 'KG' }}</el-radio>
                      <el-radio :label="'1'">{{ 'CBM' }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <!-- PO原单号-->
                  <el-form-item :label="$t('Warehouse.PoOriginalOrderNo')" prop="poNumber">
                    <el-input v-model="form.poNumber" no="poNumber" />
                  </el-form-item>
                  <!-- 邮编-->
                  <el-form-item :label="$t('SeaExport.ZIP')" prop="zip">
                    <el-input v-model="form.zipCode" no="zip" />
                  </el-form-item>
                  <!-- 计泡系数-->
                  <el-form-item :label="$t('FbaChannel.bubbleCountingRatio')">
                    <el-input v-model="form.bubbleCountingRatio" />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <!-- 服务渠道-->
                  <el-form-item :label="$t('Warehouse.ServiceChannel')" prop="serviceChannel">
                    <cargo-advance-select
                      no="serviceChannel"
                      disabled
                      :select-type="selectTypeNames.basic_data_FbaChannel"
                      filterable
                      :clearable="true"
                      :default-value="form.serviceChannel"
                      @parentCallBack="p=>{form.serviceChannel=p.value;}"
                    />
                  </el-form-item>
                  <!-- 目的地派送方式-->
                  <el-form-item :label="$t('Warehouse.DestinationDeliveryMethod')" prop="deliveryMethod">
                    <cargo-advance-select
                      no="destinationDistribution"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES"
                      filterable
                      :clearable="false"
                      :default-value="form.destinationDistribution"
                      @parentCallBack="p=>{form.destinationDistribution=p.value}"
                    />
                  </el-form-item>
                  <!-- 分泡比例-->
                  <el-form-item :label="$t('FbaJob.BubbleSplittingRatio')">
                    <el-input-number v-model="form.bubbleSplittingRatio" style="width: 100px;" controls-position="right" :max="100" :min="0" :precision="0" />%
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <!-- 运输方式-->
                  <el-form-item :label="$t('Pricing.TransportMode')" prop="shippingType">
                    <cargo-advance-select
                      no="shippingType"
                      :select-type="selectTypeNames.local_cache_FbaJobConstants$SHIPPING_TYPES"
                      filterable
                      :clearable="false"
                      :default-value="form.shippingType"
                      @parentCallBack="p=>{form.shippingType=p.value;}"
                    />
                  </el-form-item>
                  <!-- 快递公司-->
                  <el-form-item v-if="form.destinationDistribution && Number(form.destinationDistribution) === 1" :label="$t('Warehouse.CourierServicesCompany')" prop="courierServicesCompany">
                    <el-select v-model="form.expressCompany" no="expressCompany" placeholder="" clearable>
                      <el-option
                        v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                        :key="item.code"
                        :label="item.chineseName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <!--仓库信息-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.WarehouseInformation') }}</span>
          <div class="form-row" style="display:flex;flex-direction:row;">
            <el-form
              label-width="110px"
              label-position="right"
              style="margin-right:10px"
            >
              <el-row>
                <el-col :span="4.8">
                  <el-form-item
                    class="required"
                    :label="$t('Warehouse.WarehouseNo')"
                    prop="warehouseNo"
                  >
                    <el-input
                      v-model="form.warehouseNo"
                      style="width:95%;"
                      :disabled="!(isEditing && !form.checklistTime)"
                      @change="warehouseNoChargeHandler"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.ReceiptNo')"
                    prop="receiptNo"
                    class="auto-width"
                  >
                    <el-input v-model="form.receiptNo" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.WarehouseName')"
                    prop="warehouse"
                    class="auto-width required"
                  >
                    <el-input v-model="form.warehouse" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Warehouseman')"
                    prop="warehouseOp"
                    class="auto-width"
                  >
                    <cargo-user-select
                      :method-params="{officeId:form.opOffice,category:'role',shape:'warehouseOp'}"
                      :default-value="form.warehouseOp||''"
                      :disabled="!isEditing"
                      style="width:95%;"
                      @change="p=>{form.warehouseOp=p.value}"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.WarehouseLocation')"
                    prop="location"
                    class="auto-width"
                  >
                    <el-input v-model="form.location" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    class="required"
                    :label="$t('Warehouse.StorageDate')"
                    prop="warehouseInDate"
                  >
                    <el-date-picker
                      v-model="form.warehouseInDate"
                      type="datetime"
                      :disabled="!isEditing"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryDate')"
                    prop="warehouseOutDate"
                    class="auto-width"
                  >
                    <el-date-picker
                      v-model="form.warehouseOutDate"
                      type="datetime"
                      disabled
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryMode')"
                    prop="outType"
                    class="auto-width"
                  >
                    <el-select
                      v-model="form.outType"
                      clearable
                      style="width: 95%;"
                      disabled
                      :placeholder="$t('Message.PleaseSelect')"
                      size="mini"
                    >
                      <el-option
                        v-for="(item,index) in WarehouseInState.WAREHOUSE_IN_OUT_TYPE"
                        :key="index"
                        :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item
                    prop="isPallet"
                  >
                    <el-checkbox v-model="form.pallet" :disabled="!isEditing" @change="daycareInformationChangeHandler">
                      {{ $t('Warehouse.DaycareInformation') }}
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    prop="isSealCargo"
                  >
                    <el-checkbox v-model="form.sealCargo" :disabled="!isEditing">{{
                      $t('Warehouse.IsTheGoodsClosed')
                    }}
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.PalletSum')"
                    prop="palletSum"
                  >
                    <el-input-number
                      v-model="form.palletSum"
                      :disabled="true"
                      controls-position="right"
                      :max="10"
                      :min="0"
                      style="width:95%;"
                      :precision="0"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DeliveryCmp')"
                    prop="DeliveryCmp"
                  >
                    <el-input v-model="form.deliveryCmp" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.LicensePlate')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.truckNo" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Driver')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.driver" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DriverPhone')"
                    prop="licensePlate"
                  >
                    <el-input v-model="form.driverTel" style="width:95%;" :disabled="!isEditing" />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.Remark')"
                    prop="licensePlate"
                  >
                    <el-input
                      v-model="form.remarks"
                      class="custom-textarea"
                      type="textarea"
                      :row="3"
                      style="width:95%;height: 64px"
                      :disabled="!isEditing"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item
                    prop="isBroken"
                  >
                    <el-checkbox v-model="form.broken" :disabled="!isEditing" @change="checkboxChangeHandler">{{
                      $t('Warehouse.IsNotComputationIsAffectedByDampness')
                    }}
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    prop="receiveDc"
                  >
                    <el-checkbox v-model="form.receiveDc" :disabled="!isEditing">{{
                      $t('Warehouse.ReceiveDc')
                    }}
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.ComputationIsAffectedByDampnessNum')"
                    prop="brokenNum"
                  >
                    <el-input-number
                      v-model="form.brokenQuantity"
                      :min="0"
                      :max="99999"
                      controls-position="right"
                      style="width:95%;"
                      :precision="0"
                      :disabled="!(isEditing && form.broken)"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.DescriptionOfGoods')"
                    prop="licensePlate"
                  >
                    <el-input
                      v-model="form.brokenDes"
                      class="custom-textarea"
                      type="textarea"
                      :row="3"
                      style="width:95%;height: 64px"
                      :disabled="!isEditing"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.HandlingOpinions')"
                    prop="licensePlate"
                  >
                    <el-input
                      v-model="form.comments"
                      class="custom-textarea"
                      type="textarea"
                      :row="3"
                      style="width:95%;height: 64px"
                      :disabled="!(isEditing && (isChecklist || isWeigh))"
                    />
                  </el-form-item>
                  <el-form-item
                    :label="$t('Warehouse.SealingWeight')"
                    prop="brokenNum"
                  >
                    <el-input-number
                      v-model="form.sealWeight"
                      :min="0"
                      :max="999999999999"
                      controls-position="right"
                      style="width:95%;"
                      :precision="1"
                      :disabled="!(isEditing && form.sealCargo)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item v-if="form.labeling" :label="$t('Warehouse.LabelingTime')" prop="LabelingTime">
                    <el-date-picker
                      v-model="form.labelingTime"
                      type="datetime"
                      :disabled="!isEditing"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.WeighTime')" prop="WeighTime">
                    <el-date-picker
                      v-model="form.weighTime"
                      type="datetime"
                      :disabled="!(isEditing && isWeigh)"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.ChecklistTime')" prop="checklistTime">
                    <el-date-picker
                      v-model="form.checklistTime"
                      type="datetime"
                      :disabled="!(isEditing && (isChecklist || isWeigh))"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.ChecklistResult')" prop="checklistResult">
                    <el-select
                      v-model="form.checklistStatus"
                      no="checklistStatus"
                      style="width: 95%;"
                      clearable
                      placeholder=""
                      :disabled="!(isEditing && (isChecklist || isWeigh))"
                    >
                      <el-option
                        v-for="item in SystemConstants.CHECKLIST_STATUS"
                        :key="item.code"
                        :label="item.chineseName"
                        :value="item.code"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.FaceOrderPrintTime')" prop="faceOrderPrintTime">
                    <el-date-picker
                      v-model="form.faceOrderPrintTime"
                      type="datetime"
                      disabled
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.CourierNumber')" prop="courierNumber" class="auto-width">
                    <el-input v-model="form.courierNumber" style="width:95%;" disabled />
                  </el-form-item>
                </el-col>
                <el-col :span="4.8">
                  <el-form-item :label="$t('SpecialGoods.StuffingTime')" prop="packingTime">
                    <el-date-picker
                      v-model="form.packingTime"
                      type="datetime"
                      :disabled="true"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.RefContainerNo')" prop="refContainerNo" class="auto-width">
                    <el-input v-model="form.refContainerNo" style="width:95%;" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.ReturnGoodsTime')" prop="returnGoodsTime">
                    <el-date-picker
                      v-model="form.returnGoodsTime"
                      type="datetime"
                      disabled
                      value-format="yyyy-MM-dd HH:mm:ss"
                      format="yyyy-MM-dd HH:mm"
                      style="width: 95%;"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('Warehouse.ReturnReason')" prop="returnReason">
                    <el-input
                      v-model="form.returnReason"
                      class="custom-textarea"
                      type="textarea"
                      :row="3"
                      style="width:95%;height: 64px"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <!--货物明细（委托）-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{
            $t('Warehouse.CargoDetails') + '(' + this.$t('CargoMsg.Cargo_Consignation') + ')'
          }}</span>
          <div class="form-row grid-list" style="min-width:1200px">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <el-form class="spacing">
                  <el-radio-group v-model="jobGoodsViewType">
                    <el-radio label="detail">{{ $t('Warehouse.Detail') }}</el-radio>
                    <el-radio label="summary">{{ $t('Warehouse.Summary') }}</el-radio>
                  </el-radio-group>
                </el-form>
                <cargo-ag-grid
                  v-if="!jobGoodsViewSummary"
                  ref="goodsDetailTableEst"
                  config-module="9300008"
                  :grid-options="detailList.goodGridOptionsEst"
                  :column-defs="dynamicGoodsColumnEstDefs"
                  :row-data="form.fbaJobGoods || []"
                  style="height: 200px"
                  @gridReady="params=>{detailList.gridApiEst=params.api}"
                />
                <cargo-ag-grid
                  v-if="jobGoodsViewSummary"
                  ref="goodsSummaryTableEst"
                  config-module="9300020"
                  :grid-options="detailList.goodGridOptionsEst"
                  :column-defs="dynamicGoodsColumnEstDefs"
                  :row-data="summaryJobGoodsDetailList || []"
                  style="height: 200px"
                  @gridReady="params=>{detailList.gridApiEst=params.api}"
                />
              </div>
            </el-form>
          </div>
        </div>
        <!--货物明细（实际）-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.CargoDetails') + '(' + this.$t('SeaExport.Actual') + ')' }}</span>
          <div class="form-row grid-list" style="min-width:1200px">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <el-form class="spacing">
                  <el-radio-group v-model="goodsViewType">
                    <el-radio label="detail">{{ $t('Warehouse.Detail') }}</el-radio>
                    <el-radio label="summary">{{ $t('Warehouse.Summary') }}</el-radio>
                  </el-radio-group>
                </el-form>
                <el-form v-if="!fbaLob" class="spacing">
                  <el-button
                    v-if="!goodsViewSummary"
                    type="primary"
                    :disabled="hasChecklistTime || !isEditing"
                    @click="addDetailHandler"
                  >{{ $t('Warehouse.AddCargo') }}
                  </el-button>
                  <el-button type="primary" :disabled="hasChecklistTime || !isEditing" @click="batchMaintenance">{{
                    $t('Warehouse.BatchMaintenance')
                  }}
                  </el-button>
                  <el-dropdown
                    no="14"
                    style="margin:0 5px;font-size: 12px"
                  >
                    <el-upload
                      :action="actionOrderUrl"
                      :headers="headers"
                      :show-file-list="false"
                      accept=".xls, .xlsx"
                      :before-upload="beforeOrderUpload"
                      :on-success="uploadOrderSuccess"
                      :on-error="handleError"
                      :data="{uuid:warehouseInUuid,type:'GN'}"
                      style="display: inline-block; margin-left: 5px"
                      :disabled="hasChecklistTime || isEditing"
                    >
                      <el-button type="primary" :disabled="hasChecklistTime || isEditing">
                        {{ $t('CargoMsg.Cargo_Import2') }}
                        <i class="el-icon-arrow-down el-icon--right" />
                      </el-button>
                    </el-upload>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="1">
                        <el-upload
                          ref="uploadOrder"
                          :action="actionOrderUrl"
                          :headers="headers"
                          :show-file-list="false"
                          accept=".xls, .xlsx"
                          :before-upload="beforeOrderUpload"
                          :on-success="uploadOrderSuccess"
                          :on-error="handleError"
                          :data="{uuid:warehouseInUuid,type:'GN'}"
                          style="display: inline-block"
                        >
                          <el-button
                            slot="trigger"
                            type="text"
                            style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;"
                          >{{
                            $t('CargoMsg.GOODS_INFO_IMPORT')
                          }}
                          </el-button>
                        </el-upload>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          no="16"
                          type="text"
                          style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;"
                          @click="downLoadDetail()"
                        >{{ $t('CargoMsg.Cargo_DownLoad_Detail') }}
                        </el-button>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <el-button
                          no="17"
                          type="text"
                          style="padding-left: 0px;color: #6F6F6F;text-align: left;width: 80px;"
                          @click="downLoadSummary()"
                        >{{ $t('CargoMsg.Cargo_DownLoad_Summary') }}
                        </el-button>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!--                  <el-button type="primary" :disabled="!isEditing" @click="batchImport">{{ $t('CargoMsg.Cargo_Import2') }}</el-button>-->
                  <el-button type="primary" :disabled="hasChecklistTime || !isEditing" @click="pickingGoods">{{
                    $t('Warehouse.PickingGoods')
                  }}
                  </el-button>
                  <!--                  <el-button type="primary" :disabled="!isEditing" @click="adjustChargeWeight">{{ $t('Warehouse.AdjustChargeWeight') }}</el-button>-->
                  <el-button type="danger" :disabled="!isEditing || hasChecklistTime" @click="clearData">{{
                    $t('CargoMsg.Cargo_Empty')
                  }}
                  </el-button>
                  <el-button type="danger" :disabled="hasChecklistTime || !isEditing" @click="delDetailHandler">{{
                    $t('Warehouse.DeleteCargo')
                  }}
                  </el-button>
                </el-form>
                <el-form class="spacing">
                  <el-button
                    v-if="fbaLob && ((source === 'fbaSea' && $checkPermission(['button_FBABookingNew_fbaSeaVerifyWarehouse'])) || (source === 'fbaAir' && $checkPermission(['button_FBAAeBooking_fbaSeaVerifyWarehouse'])) || (source === 'fbaRailway' && $checkPermission(['button_FBARailwayExport_fbaRailVerifyWarehouse'])))"
                    style="margin-left: 10px;"
                    type="primary"
                    :disabled="!(action === 'look' && !form.checklistTime && form.warehouseInDetailList && form.warehouseInDetailList.length > 0)"
                    @click="onCheckList()"
                  >{{ $t('Warehouse.Checklist') }}
                  </el-button>
                </el-form>
                <el-form :disabled="!!form.checklistTime">
                  <cargo-ag-grid
                    v-if="!goodsViewSummary"
                    ref="goodsDetailTable"
                    config-module="9300009"
                    :grid-options="detailList.goodGridOptions"
                    :column-defs="dynamicGoodsColumnDefs"
                    :row-data="form.warehouseInDetailList || []"
                    style="height: 200px"
                    @gridReady="params=>{detailList.gridApi=params.api}"
                  />
                  <cargo-ag-grid
                    v-if="goodsViewSummary"
                    ref="goodsSummaryDTable"
                    config-module="9300010"
                    :grid-options="detailList.goodGridOptions"
                    :column-defs="dynamicGoodsColumnDefs"
                    :row-data="summaryGoodsDetailList || []"
                    style="height: 200px"
                    @gridReady="params=>{detailList.gridApi=params.api}"
                  />
                </el-form>
                <el-form-item class="auto-width">
                  <div style="display: flex;text-align: left" class="title-row">
                    <div
                      style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:100px;text-align: right;"
                    >
                      {{ $t('SeaExport.Quantity') }}
                    </div>
                    <div
                      style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:170px;text-align: right;"
                    >
                      {{ $t('SeaExport.Weight2') }} KGS
                    </div>
                    <div
                      style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:150px;text-align: right;"
                    >
                      {{ $t('SeaExport.Cubage') }} CBM
                    </div>
                    <div
                      style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:150px;text-align: right;"
                    >
                      {{ $t('SeaExport.VolumetricWeight') }} KGS
                    </div>
                    <div
                      style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:170px;text-align: right;"
                    >
                      {{ $t('SeaExport.ChargedWeight') }} M/T
                    </div>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Actual')" class="auto-width">
                  <input
                    v-model="form.quantitySum"
                    disabled
                    :style="{color: Number(form.quantitySum) === Number(form.quantityContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                  <input
                    v-model="form.weightSum"
                    disabled
                    :style="{color: Number(form.weightSum) === Number(form.weightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                  <input
                    v-model="form.cubageSum"
                    disabled
                    :style="{color: Number(form.cubageSum) === Number(form.cubageContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                  <input
                    v-model="form.volumetricWeightAct"
                    disabled
                    :style="{color: Number(form.volumetricWeightAct) === Number(form.volumetricWeightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                  <input
                    v-model="form.chargeWeightAct"
                    :disabled="!isEditing"
                    :style="{color: Number(form.chargeWeightAct) === Number(form.chargeWeightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                    @change="chargeWeightActChange"
                  >
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Consignation')" class="auto-width">
                  <input
                    v-model="form.quantityContract"
                    disabled
                    :style="{color: Number(form.quantitySum) === Number(form.quantityContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                  <input
                    v-model="form.weightContract"
                    disabled
                    :style="{color: Number(form.weightSum) === Number(form.weightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                  <input
                    v-model="form.cubageContract"
                    disabled
                    :style="{color: Number(form.cubageSum) === Number(form.cubageContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                  <input
                    v-model="form.volumetricWeightContract"
                    disabled
                    :style="{color: Number(form.volumetricWeightAct) === Number(form.volumetricWeightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                  <input
                    v-model="form.chargeWeightContract"
                    disabled
                    :style="{color: Number(form.chargeWeightAct) === Number(form.chargeWeightContract) ? 'black' : 'red', minHeight:'28px', minLength:'104px', textAlign:'center'}"
                  >
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
        <!--货物照片-->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.CargoPhotos') }}</span>
          <div class="form-row grid-list" style="min-width:1200px">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <el-form v-if="!fbaLob" class="spacing">
                <el-upload
                  :action="`${URL.warehouseIn.uploadFileForWarehouseIn}?warehouseInUuid=${warehouseInUuid}`"
                  :headers="{sessionId:$store.getters.token}"
                  :show-file-list="false"
                  :on-success="uploadSuccess"
                  :on-change="toChooseFile"
                  :disabled="!isEditing"
                  style="display: inline-block;margin-right: 5px;"
                >
                  <el-button type="primary" :disabled="!isEditing">{{ $t('Warehouse.SelectFile') }}</el-button>
                </el-upload>
                <el-button type="danger" :disabled="!isEditing" @click="delPhotoHandler">{{
                  $t('Warehouse.DeleteFile')
                }}
                </el-button>
              </el-form>
              <cargo-ag-grid
                ref="photosList"
                config-module="9300013"
                :grid-options="photoList.gridOptions"
                :column-defs="photoList.photoColumn"
                :row-data="form.businessDocumentVOList || []"
                style="height: 200px"
                @gridReady="params=>{photoList.gridApi=params.api}"
              />
            </el-form>
          </div>
        </div>
        <!-- 操作要求 -->
        <div class="section" style="width:90%; min-width:1200px">
          <span class="title">{{ $t('Warehouse.OperationRequirements') }}</span>
          <div class="form-row grid-list" style="min-width:1200px">
            <el-form
              label-width="100px"
              label-position="left"
              :disabled="!isEditing"
              style="margin-right:10px"
            >
              <div>
                <cargo-ag-grid
                  ref="opList"
                  config-module="9300004"
                  :grid-options="opList.options"
                  :column-defs="opList.opColumn"
                  :row-data="form.operationRequirementVOList || []"
                  style="height: 200px"
                  @gridReady="params=>{opList.gridApi=params.api}"
                />
              </div>
            </el-form>
          </div>
        </div>
      </el-collapse>
    </el-form>
    <!-- 货箱编号编辑弹窗 -->
    <container-no-editor
      v-if="containerNoEditor.visible"
      :boxes-number="containerNoEditor.boxesNumber"
      :visible.sync="containerNoEditor.visible"
      :shipment-id="containerNoEditor.shipmentId"
      :source="goodsViewType"
      :container-no="containerNoEditor.containerNo"
      :warehouse-in-detail-list="form.warehouseInDetailList"
      @summarySaveCallBack="containerNoEditor.summarySaveCallBack"
      @detailSaveCallBack="containerNoEditor.detailSaveCallBack"
      @close="containerNoEditor.visible=false"
    />
    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="fileTypeEditor.lob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      @saveFileType="itemEditEndHandler"
    />
    <!-- 选择业务弹框 -->
    <job-nos-window
      v-if="jobNosWindow.visible"
      :visible.sync="jobNosWindow.visible"
      :job-nos="jobNosWindow.jobs"
      @selectJobNoHandler="selectJobNoHandler"
    />
    <!-- 核单 -->
    <el-dialog
      v-if="checklist.visible"
      v-el-drag-dialog
      :visible.sync="checklist.visible"
      :title="$t('Warehouse.Checklist')"
      width="340px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('Warehouse.ChecklistTime')">
          <el-date-picker
            v-model="checklist.checklistTime"
            no="checklistTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
            style="width:195px"
            :placeholder="$t('SeaExport.SelectTime')"
          />
        </el-form-item>
        <el-form-item :label="$t('Warehouse.ChecklistResult')">
          <el-select v-model="checklist.checklistStatus" no="checklistStatus" style="width:195px;" placeholder="">
            <el-option
              v-for="item in SystemConstants.CHECKLIST_STATUS"
              :key="item.code"
              :label="item.chineseName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Warehouse.HandlingOpinions')">
          <el-input v-model="checklist.comments" type="textarea" :row="5" style="width:195px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" @click="toChecklist">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="checklist.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量维护弹窗 -->
    <batch-maintenance-dialog
      v-if="batchMaintenanceDialog.visible"
      :visible.sync="batchMaintenanceDialog.visible"
      :job-key="jobUuid"
      :exist-detail-list="form.warehouseInDetailList"
      @saveCallBack="batchMaintenanceDialog.saveCallBack"
      @close="batchMaintenanceDialog.visible=false"
    />
  </div>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import { getLoading } from '@/utils/utilBaseElement'
import {
  getFbaJobByWarehouseNo,
  getFbaJobDetailByKey,
  loadWarehouseInRelated,
  updateFields
} from '@/api/warehouseIn/warehouseIn'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoDateTimePicker from '@/components/Cargo/Common/CargoDateTimePicker'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import { cache, cacheName } from '@/utils/cacheManager'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import JobNosWindow from '@/components/Cargo/Warehouse/components/warehousing/jobNosWindow'
import { DocumentTypeUtil } from '@/class/cargo/model/utils/DocumentTypeUtil'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { FbaWarehouseInDetail } from '@/class/model/booking/FbaWarehouseInDetail'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { getGridSelected } from '@/utils/agGrid'
import ContainerNoEditor from '@/views/cargo/v0/FBA/ContainerNoEditor'
import { TabError } from '@/utils/class/TabError'
import moment from 'moment'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import BatchMaintenanceDialog from '@/views/cargo/v0/FBA/batchMaintenanceDialog'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { FbaQuotation } from '@/class/model/price/FbaQuotation'
import { FbaQuotationUtil } from '@/class/cargo/model/utils/FbaQuotationUtil'
import { getJobAvailableChannels } from '@/api/Fba/fbaChannel'
import { getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'

export default {
  name: 'FbaWarehousingDetail',
  components: {
    JobNosWindow,
    cargoAdvanceSelect,
    cargoUserSelect,
    cargoCompanySelect,
    MxFileTypeEditor,
    ContainerNoEditor,
    CargoDateTimePicker,
    BatchMaintenanceDialog
  },
  props: {
    warehouseInUuid: { type: String, default: () => '' },
    action: { type: String, required: true },
    lob: { type: String, required: true },
    context: {
      type: Object, default: () => {
      }
    },
    source: { type: String, required: false },
    opType: { type: String, required: false },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      headers: {
        sessionId: this.$store.getters.token,
        ContentType: 'multipart/form-data'
      },
      SystemConstants,
      WarehouseInState,
      FbaJobConstants,
      documentTypeUtil: null,
      selectTypeNames: TYPE_NAMES,
      URL,
      jobUuid: '',
      bubbleCountingRatio: 0.0,
      goodsViewType: 'detail',
      jobGoodsViewType: 'detail',
      channel4JobSelect: [],
      fbaQuotation: null,
      fbaChannel: null,
      refreshCharge: false,
      storageURL: '',
      filter: {},
      addCargoVisible: false,
      gridApi: null,
      fileTypeEditor: {
        visible: false,
        fileId: '',
        lob: 'SE',
        fileCategory: ''
      },
      batchMaintenanceDialog: {
        visible: false,
        saveCallBack: (detailList) => {
          this.calcSingleVolumetricWeightAndChargeWeight(detailList)
          this.form.warehouseInDetailList = this.form.warehouseInDetailList.concat(detailList)
          this.calcActJmt()
          this.genSummaryGoodsDetailList()
        }
      },
      containerNoEditor: {
        visible: false,
        shipmentId: '',
        boxesNumber: 0,
        key: '',
        containerNo: '',
        summarySaveCallBack: (result) => {
          const { startSeq, boxSeqLen, containerNo } = result
          const key = this.containerNoEditor.key
          const summaryGoodsDetailList = []
          // 更新箱货信息-汇总
          this.summaryGoodsDetailList.forEach(summaryGoodsDetail => {
            if (summaryGoodsDetail.key === key) {
              summaryGoodsDetail.containerNo = containerNo
            }
            summaryGoodsDetailList.push(summaryGoodsDetail)
          })
          this.summaryGoodsDetailList = summaryGoodsDetailList
          // 更新箱货信息-明细
          let index = Number(startSeq)
          this.summaryAndDetailGoodsRel[key].forEach(goodsDetail => {
            goodsDetail.containerNo = this.containerNoEditor.shipmentId + index.toString().padStart(boxSeqLen, '0')
            goodsDetail.updated = true
            index++
          })
          this.form.updateCargoDetail = true
        },
        detailSaveCallBack: (result) => {
          const { containerNo } = result
          const goodsDetailList = []
          this.form.warehouseInDetailList.forEach(goodsDetail => {
            const key = goodsDetail.uuid ? goodsDetail.uuid : goodsDetail.tmpUuid
            if (key === this.containerNoEditor.key) {
              goodsDetail.containerNo = containerNo
              goodsDetail.updated = true
            }
            goodsDetailList.push(goodsDetail)
          })
          this.form.warehouseInDetailList = goodsDetailList
          this.genSummaryGoodsDetailList()
        }
      },
      jobNosWindow: {
        visible: false,
        jobs: []
      },
      fileTypeMap: {},
      jobKeyOld: '',
      selectedLocalAddedService: [],
      localAddedService: [],
      selectedPodAddedService: [],
      podAddedService: [],
      form: new WarehouseIn().fillDefaultValue().getData(),
      oldWarehouseNo: '',
      // 货物明细（委托）汇总数据
      summaryJobGoodsDetailList: [],
      // 货物明细（实际）汇总数据
      summaryGoodsDetailList: [],
      // 货物明细（实际）汇总数据与明细数据关联关系对象，key为汇总条件json
      summaryAndDetailGoodsRel: {},
      detailList: {
        gridApiEst: null,
        goodGridOptionsEst: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptionsEst.selectedRowIndex = event.rowIndex
          }
        },
        goodsDetailColumnEst: [
          {
            headerName: this.$t('Warehouse.ContainerNo'), field: 'containerNo', colId: 'containerNo', minWidth: 150
          }, {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150
          }, {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('boxesNumber', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          }, {
            headerName: this.$t('Warehouse.SingleBoxWeight'),
            field: 'singleBoxWeight',
            colId: 'singleBoxWeight',
            minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('singleBoxWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('boxLength', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('boxWidth', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.form.warehouseInDetailList || []
              return this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('chargeWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'), field: 'volumetricWeight', colId: 'volumetricWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('volumetricWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
            field: 'cargoEnglishName',
            colId: 'cargoEnglishName',
            minWidth: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
            field: 'cargoChineseName',
            colId: 'cargoChineseName',
            minWidth: 150
          }, {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          }, {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150
          }, {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.MaterialQuality'),
            field: 'materialQuality',
            colId: 'materialQuality',
            minWidth: 150
          }, {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('Warehouse.ProductDescription'),
            field: 'productDescription',
            colId: 'productDescription',
            minWidth: 150
          }
        ],
        goodsSummaryColumnEst: [
          {
            headerName: this.$t('Warehouse.ContainerNo'), field: 'containerNo', colId: 'containerNo', minWidth: 150
          }, {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150
          }, {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('boxesNumber', current, warehouseInDetailList)
            }
          }, {
            headerName: this.$t('Warehouse.SingleBoxWeight'),
            field: 'singleBoxWeight',
            colId: 'singleBoxWeight',
            minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('singleBoxWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('boxLength', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('boxWidth', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('boxHeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('chargeWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'), field: 'volumetricWeight', colId: 'volumetricWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const warehouseInDetailList = this.summaryGoodsDetailList || []
              return this.compareEstWarehouseInField('volumetricWeight', current, warehouseInDetailList)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
            field: 'cargoEnglishName',
            colId: 'cargoEnglishName',
            minWidth: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
            field: 'cargoChineseName',
            colId: 'cargoChineseName',
            minWidth: 150
          }, {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          }, {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150
          }, {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.MaterialQuality'),
            field: 'materialQuality',
            colId: 'materialQuality',
            minWidth: 150
          }, {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            }
          }, {
            headerName: this.$t('Warehouse.ProductDescription'),
            field: 'productDescription',
            colId: 'productDescription',
            minWidth: 150
          }, {
            headerName: this.$t('Warehouse.PalletNo'), field: 'palletNo', colId: 'palletNo', minWidth: 150
          }
        ],
        gridApi: null,
        goodGridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          selectedRowIndex: -1,
          singleClickEdit: true,
          onCellFocused: event => {
            this.detailList.goodGridOptions.selectedRowIndex = event.rowIndex
            if (this.goodsViewSummary) {
              this.onSummaryContainerNoCellFocused(event)
            } else {
              this.onDetailContainerNoCellFocused(event)
            }
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        },
        goodsDetailColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: this.$t('Warehouse.ContainerNo'),
            headerClass: 'blueStyle',
            field: 'containerNo',
            colId: 'containerNo',
            minWidth: 150
          }, {
            headerName: 'Shipment Id', field: 'shipmentId', colId: 'shipmentId', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('boxesNumber', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            }
          }, {
            headerName: this.$t('Warehouse.SingleBoxWeight'),
            headerClass: 'blueStyle',
            field: 'singleBoxWeight',
            colId: 'singleBoxWeight',
            minWidth: 150,
            editable: () => this.isEditing,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('singleBoxWeight', current, fbaJobGoods)
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('boxLength', current, fbaJobGoods)
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('boxWidth', current, fbaJobGoods)
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.form.fbaJobGoods || []
              return this.compareEstWarehouseInField('boxHeight', current, fbaJobGoods)
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('chargeWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'), field: 'volumetricWeight', colId: 'volumetricWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('volumetricWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
            headerClass: 'blueStyle',
            field: 'cargoEnglishName',
            colId: 'cargoEnglishName',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
            headerClass: 'blueStyle',
            field: 'cargoChineseName',
            colId: 'cargoChineseName',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.MaterialQuality'),
            field: 'materialQuality',
            colId: 'materialQuality',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.ElectricCol'), field: 'electric', colId: 'electric', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.MagneticCol'), field: 'magnetic', colId: 'magnetic', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.PowderyCol'), field: 'powdery', colId: 'powdery', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.LiquidCol'), field: 'liquid', colId: 'liquid', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ProductDescription'),
            field: 'productDescription',
            colId: 'productDescription',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PalletNo'), field: 'palletNo', colId: 'palletNo', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.palletContainerNum'),
            field: 'palletContainerNum',
            colId: 'palletContainerNum',
            minWidth: 150,
            valueFormatter: params => {
              return params.data.palletUuid ? 1 : 0
            }
          }, {
            headerName: this.$t('Warehouse.otherContainerNum'),
            field: 'otherContainerNum',
            colId: 'otherContainerNum',
            minWidth: 150,
            valueFormatter: params => {
              return params.data.palletUuid ? 0 : 1
            }
          }
        ],
        goodsSummaryColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: this.$t('Warehouse.ContainerNo'),
            headerClass: 'blueStyle',
            field: 'containerNo', colId: 'containerNo', minWidth: 150
          }, {
            headerName: 'Shipment Id',
            headerClass: 'blueStyle',
            field: 'shipmentId', colId: 'shipmentId', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'Reference Id', field: 'referenceId', colId: 'referenceId', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BoxesNumber'), field: 'boxesNumber', colId: 'boxesNumber', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('boxesNumber', current, fbaJobGoods)
            }
          }, {
            headerName: this.$t('Warehouse.SingleBoxWeight'),
            headerClass: 'blueStyle',
            field: 'singleBoxWeight',
            colId: 'singleBoxWeight',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('singleBoxWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxLength'), field: 'boxLength', colId: 'boxLength', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('boxLength', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxWidth'), field: 'boxWidth', colId: 'boxWidth', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('boxWidth', current, fbaJobGoods)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Warehouse.BoxHeight'), field: 'boxHeight', colId: 'boxHeight', minWidth: 150,
            headerClass: 'blueStyle',
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('boxHeight', current, fbaJobGoods)
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
              this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
            }
          }, {
            headerName: this.$t('Pricing.ChargedWeight'), field: 'chargeWeight', colId: 'chargeWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('chargeWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('SeaExport.VolumetricWeight'), field: 'volumetricWeight', colId: 'volumetricWeight', minWidth: 150,
            cellStyle: (params) => {
              const current = params.data
              const fbaJobGoods = this.summaryJobGoodsDetailList || []
              return this.compareEstWarehouseInField('volumetricWeight', current, fbaJobGoods)
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_EnglishCargoName'),
            headerClass: 'blueStyle',
            field: 'cargoEnglishName',
            colId: 'cargoEnglishName',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_ChineseCargoName'),
            headerClass: 'blueStyle',
            field: 'cargoChineseName',
            colId: 'cargoChineseName',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.UnitRate'), field: 'unitRate', colId: 'unitRate', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Quantity'), field: 'quantity', colId: 'quantity', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 0,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.HsCode'), field: 'hsCode', colId: 'hsCode', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Brand'), field: 'brand', colId: 'brand', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.BrandType'), field: 'brandType', colId: 'brandType', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ModelNo'), field: 'modelNo', colId: 'modelNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'SKU NO', field: 'skuNo', colId: 'skuNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: 'UPC NO', field: 'upcNo', colId: 'upcNo', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.MaterialQuality'),
            field: 'materialQuality',
            colId: 'materialQuality',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.Purpose'), field: 'purpose', colId: 'purpose', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesLink'), field: 'salesLink', colId: 'salesLink', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.SalesPrice'), field: 'salesPrice', colId: 'salesPrice', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PictureUrl'), field: 'pictureUrl', colId: 'pictureUrl', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.WeightKg'), field: 'weight', colId: 'weight', minWidth: 150,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.000')
            }
          }, {
            headerName: 'ASIN', field: 'asin', colId: 'asin', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.CargoType'), field: 'cargoType', colId: 'cargoType', minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_CargoType,
                methodParams: { fbaSea: true, fbaAir: true, fbaRailway: true, collectionType: 'or' },
                tagValue: 'code',
                tagName: 'chineseName',
                filterable: true
              }
            },
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.ElectricCol'), field: 'electric', colId: 'electric', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.MagneticCol'), field: 'magnetic', colId: 'magnetic', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.PowderyCol'), field: 'powdery', colId: 'powdery', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('FbaJob.LiquidCol'), field: 'liquid', colId: 'liquid', minWidth: 150,
            valueFormatter: (params) => {
              return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
            },
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                tagValue: 'code',
                tagName: 'value',
                staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, {
                  code: true,
                  value: this.$t('SeaExport.Yes')
                }]
              }
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.ProductDescription'),
            field: 'productDescription',
            colId: 'productDescription',
            minWidth: 150,
            editable: () => this.isEditing,
            cellEditor: 'CargoAgGridCommonInputEditor',
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          }, {
            headerName: this.$t('Warehouse.PalletNo'), field: 'palletNo', colId: 'palletNo', minWidth: 150
          }, {
            headerName: this.$t('Warehouse.palletContainerNum'),
            field: 'palletContainerNum',
            colId: 'palletContainerNum',
            minWidth: 150
          }, {
            headerName: this.$t('Warehouse.otherContainerNum'),
            field: 'otherContainerNum',
            colId: 'otherContainerNum',
            minWidth: 150
          }
        ]
      },
      photoList: {
        gridApi: null,
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          selectedRowIndex: -1,
          context: {
            componentParent: this
          },
          // 选中 文件类型
          onCellFocused: (event) => {
            this.onFileTypeCellFocused(event)
          },
          columnApi: null
        }, photoColumn: [
          {
            headerName: '', width: 60, checkboxSelection: true,
            sortable: false, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileName'),
            colId: 'fileName',
            field: 'fileName',
            width: 150,
            cellRenderer: params => {
              return `<a href="${URL.common.findByFileId}/${params.data.documentId}?sessionId=${this.$store.getters.userInfo.sessionId}" target="_blank" style="color:#46a6ff">${params.value}</a>`
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileType'),
            colId: 'fileType',
            field: 'fileType',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileSize'),
            field: 'fileSize',
            width: 200,
            cellRenderer: params => {
              return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_UploadTime'), colId: 'dateCreated', field: 'dateCreated', width: 150 },
          {
            headerName: this.$t('SeaExport.DocumentType'), colId: 'fileCategory', field: 'fileCategory', width: 150,
            cellRenderer: params => {
              return this.documentTypeUtil.fileTypeLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.UploadProgress'),
            colId: 'documentId',
            field: 'documentId',
            width: 115,
            cellRenderer: params => {
              if (params.value && !params.data.newData) {
                return `<span style="color:green">${this.$t('Message.Uploaded')}</span>`
              }
              if (!this.isEditing && params.data.newData) {
                return this.$t('queryJob.uploading') + '...'
              }
              return this.$t('Message.Waiting')
            }
          }
        ]
      },
      opList: {
        gridApi: null,
        options: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          columnApi: null,
          context: {
            componentParent: this
          }
        },
        opColumn: [
          {
            headerName: this.$t('CargoMsg.Cargo_OperationRequirement'),
            colId: 'contentDescription',
            field: 'contentDescription',
            width: 750,
            editable: false
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Finished'),
            field: 'finished',
            suppressMenu: true,
            width: 150,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: !this.isEditing,
              tag: 'el-checkbox'
            }
          }
        ]
      },
      opGridParams: {},
      collapse: [0, 1, 2, 3, 4, 5],
      warehouseInInfo: null,
      delBusinessDocumentKeys: [], // 删除文件
      delWarehouseInDetailKeys: [], // 删除货物明细
      checklist: { // 核单
        visible: false,
        checklistTime: '',
        comments: '',
        checklistStatus: 1
      },
      JobUtils
    }
  },
  computed: {
    isFba() { // 是否fba
      return this.lob === 'FBA'
    },
    fbaLob() {
      return this.source === 'fbaSea' || this.source === 'fbaAir' || this.source === 'fbaRailway'
    },
    goodsViewSummary() {
      return this.goodsViewType === 'summary'
    },
    jobGoodsViewSummary() {
      return this.jobGoodsViewType === 'summary'
    },
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEditing
    },
    detailListSelectedRow() {
      return this.form.warehouseInDetailList[this.detailList.goodGridOptions.selectedRowIndex]
    },
    photoListSelectedRow() {
      return this.form.businessDocumentVOList[this.photoList.gridOptions.selectedRowIndex]
    },
    isEditing() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !this.fbaLob
    },
    isNew() { // 新增即入库
      return this.action === 'add'
    },
    isWeigh() { // 是否称重
      return this.opType === 'weigh'
    },
    isChecklist() {
      return this.opType === 'checklist'
    },
    hasChecklistTime() {
      return !!this.form.checklistTime
    },
    actionOrderUrl() {
      return URL.fba.fbaBatchImportOnOrder
    },
    dynamicGoodsColumnDefs() {
      let columnDef = []
      if (this.goodsViewSummary) {
        columnDef = this.detailList.goodsSummaryColumn
      } else {
        columnDef = this.detailList.goodsDetailColumn
      }
      return columnDef
    },
    dynamicGoodsColumnEstDefs() {
      let columnDef = []
      if (this.jobGoodsViewSummary) {
        columnDef = this.detailList.goodsSummaryColumnEst
      } else {
        columnDef = this.detailList.goodsDetailColumnEst
      }
      return columnDef
    },
    destinations() { // 目的地 可选项
      return JobUtils.initDestination()
    }
  },
  watch: {},
  async created() {
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
  },
  mounted() {
    this.init()
  },
  methods: {
    downLoadDetail() {
      ExportUtils.downloadTemplateFile('ImportCaseGoodsDetail.xlsx', 'fba')
    },
    downLoadSummary() {
      ExportUtils.downloadTemplateFile('ImportCaseGoodsSummary.xlsx', 'fba')
    },
    // 上传成功
    async uploadOrderSuccess(res, file, fileList) {
      const { data } = res
      this.loading.close()
      this.$confirm(data.message, this.$t('queryJob.uploadSucceeded'), {
        cancelButtonText: this.$t('Partners.downloadImportResults'),
        confirmButtonText: this.$t('Message.Confirm'),
        distinguishCancelAndClose: true,
        beforeClose: async(action, instance, done) => {
          if (action === 'cancel') {
            await cache.load(cacheName.USER, cacheName.CONFIG)
            const storageUrl = cache.config.get('StorageURL')
            const url = `${URL.common.findByFileId}/${data.data}?sessionId=${this.$store.getters.token}`
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = url
            el.target = '_blank'
            el.click()
            document.body.removeChild(el)
          } else {
            done()
          }
        }
      })
      // 通过code码 判断是否刷新页面
      if (res.code === '0') {
        this.$emit('success')
      }
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.loading.close()
    },
    beforeOrderUpload(file) {
      this.loading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.loading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    async init() {
      this.documentTypeUtil = await DocumentTypeUtil.getInstance()
    },
    async onShow(row, isRefresh) {
      this.jobUuid = row.jobUuid
      this.fbaQuotation = null
      this.fbaChannel = null
      if (row.fbaPallets) { // 托盘数量=打托信息页签维护的托盘数量
        row.palletSum = row.fbaPallets.length || 0
      }
      if (!isRefresh) {
        return
      }
      if (this.fbaLob) { // 根据业务货物国外仓数据
        await this.getWarehouse(row)
      } else {
        this.form = new WarehouseIn().fillDefaultValue().getData()
        if (this.action === 'add') {
          this.summaryJobGoodsDetailList = []
          this.summaryGoodsDetailList = []
          this.summaryAndDetailGoodsRel = {}
        } else {
          for (const key in row) {
            this.form[key] = row[key]
          }
        }
        await this.initWarehouse()
      }
    },
    // 根据业务加载国内仓信息
    async getWarehouse(row) {
      const params = {}
      params.jobUuid = row.uuid
      params.oversea = false
      await loadWarehouseInRelated(params).then(res => {
        const warehouseIn = new WarehouseIn().fillDefaultValue().getData()
        const items = res.data
        if (items.warehouseIn) { //
          for (const key in items.warehouseIn) {
            if (typeof warehouseIn[key] === 'object') {
              continue
            }
            warehouseIn[key] = items.warehouseIn[key]
          }
        }
        for (const key in items) {
          if (key === 'warehouseIn') {
            continue
          }
          warehouseIn[key] = items[key] || null
        }
        this.form = warehouseIn
        this.initWarehouse()
      })
    },
    // 初始化国外仓相关数据
    async initWarehouse() {
      this.form.updateCargoDetail = false
      if (this.form.jobNo && (this.form.bubbleCountingRatio || typeof this.form.bubbleCountingRatio === 'number')) {
        this.bubbleCountingRatio = Number(this.form.bubbleCountingRatio)
      } else {
        this.bubbleCountingRatio = 6000.0
      }
      // 初始化渠道相关
      await getJobAvailableChannels({ tenantId: this.tenantId }).then(res => {
        this.channel4JobSelect = res.data
      })
      const channel = this.channel4JobSelect.find(e => this.form.serviceChannel === e.channelName)
      if (channel) {
        this.fbaChannel = channel
        this.fbaQuotation = new FbaQuotation().fillDefaultValue().getData()
        this.fbaQuotation.uuid = channel.quotationUuid
        const jobModel = new FbaQuotation(this.fbaQuotation)
        await jobModel.loadFbaQuotationRelated({
          quotation: true,
          label: true,
          partitionSetting: true,
          setupSetting: true,
          charge: true,
          customerPrice: true
        })
      }
      this.initAddedService()
      this.calcEstJmt()
      this.calcActJmt(true)
      this.genSummaryGoodsDetailList()
      this.genSummaryJobGoodsDetailList()
      this.jobKeyOld = this.form.jobKey
      this.oldWarehouseNo = this.form.warehouseNo
      this.delWarehouseInDetailKeys = []
      // 清空选中背景色
      if (this.detailList.gridApiEst) this.detailList.gridApiEst.clearFocusedCell()
      if (this.detailList.gridApi) this.detailList.gridApi.clearFocusedCell()
      if (this.photoList.gridApi) this.photoList.gridApi.clearFocusedCell()
      if (this.opList.gridApi) this.opList.gridApi.clearFocusedCell()
      if (this.isWeigh && this.isEditing) {
        if (!this.form.weighTime) { // 称重时间默认为当前时间
          this.form.weighTime = new Date()
        }
      }
      // 单票核单进入详情时
      if (this.isChecklist && this.isEditing) {
        // 核单结果默认为 通过 =1
        if (!this.form.checklistStatus && this.form.checklistStatus !== 0) {
          this.form.checklistStatus = 1
        }
      }
    },
    initAddedService() {
      this.localAddedService = []
      this.podAddedService = []
      this.selectedLocalAddedService = []
      this.selectedPodAddedService = []
      // 初始化增值服务
      let valueAddedServices = []
      if (this.form.valueAddedServices && this.form.valueAddedServices.split(',').length > 0) {
        valueAddedServices = this.form.valueAddedServices.split(',')
      }
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_ValueAddedService)
      for (const item of res) {
        if ((this.form.shippingType === 'SE' && item.fbaSea) || (this.form.shippingType === 'AE' && item.fbaAir) || (this.form.shippingType === 'RE' && item.fbaRailway)) {
          switch (Number(item.serviceType)) {
            case 0:
              this.localAddedService.push(item)
              if (valueAddedServices.indexOf(item.code) >= 0) {
                this.form[item.code] = true
                this.selectedLocalAddedService.push(item.code)
              }
              break
            case 1:
              this.podAddedService.push(item)
              if (valueAddedServices.indexOf(item.code) >= 0) {
                this.form[item.code] = true
                this.selectedPodAddedService.push(item.code)
              }
              break
          }
        }
      }
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t('Message.TheExceeds20MBAndUploaded'))
        return
      }
    },
    // 上传成功
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        const document = {}
        document.warehouseInUuid = response.data.warehouseInUuid
        document.createdBy = response.data.createdBy
        document.dateCreated = response.data.dateCreated
        document.documentCategory = response.data.documentCategory
        document.documentId = response.data.documentId
        document.fileName = response.data.fileName
        document.fileSize = response.data.fileSize
        document.fileType = response.data.fileType
        document.fileCategory = response.data.fileCategory
        document.newData = true
        document.updated = true
        this.form.businessDocumentVOList.push(document)
      } else {
        this.$message.warning(this.$t('Message.UploadPleaseContactTheAdministrator'))
      }
    },
    // 生成委托汇总数据
    genSummaryJobGoodsDetailList() {
      this.doGenerate('est')
    },
    // 生成实际汇总数据
    genSummaryGoodsDetailList() {
      this.doGenerate('act')
    },
    // 生成汇总数据
    doGenerate(type) {
      // key为相同合并条件json
      const sameGoods = {}
      const result = []
      const keys = []
      const sourceData = type === 'act' ? this.form.warehouseInDetailList : this.form.fbaJobGoods
      for (const item of sourceData) {
        const obj = {
          boxSeqLen: item.containerNo.substring(item.shipmentId.length).length,
          shipmentId: item.shipmentId,
          referenceId: item.referenceId,
          singleBoxWeight: this.$numeral(item.singleBoxWeight).format('0'),
          boxLength: this.$numeral(item.boxLength).format('0.000'),
          boxWidth: this.$numeral(item.boxWidth).format('0.000'),
          boxHeight: this.$numeral(item.boxHeight).format('0.000'),
          chargeWeight: this.$numeral(item.chargeWeight).format('0.000'),
          volumetricWeight: this.$numeral(item.volumetricWeight).format('0.000'),
          cargoEnglishName: item.cargoEnglishName,
          cargoChineseName: item.cargoChineseName
        }
        const key = JSON.stringify(obj)
        const currentSeq = Number(item.containerNo.substring(item.shipmentId.length))
        // 没有匹配到key则为新的一条汇总数据
        if (!sameGoods[key]) {
          keys.push(key)
          sameGoods[key] = { key: key, beginSeq: currentSeq, endSeq: currentSeq, ...item }
          sameGoods[key].boxesNumber = Number(item.boxesNumber)
          sameGoods[key].weight = Number(item.weight)
          // 实际货物明细额外操作
          if (type === 'act') {
            sameGoods[key].palletContainerNum = item.palletUuid ? 1 : 0
            sameGoods[key].otherContainerNum = item.palletUuid ? 0 : 1
            // 把当前明细数据与汇总数据通过key建立关联关系，方便后续对汇总数据的操作同步至明细
            this.summaryAndDetailGoodsRel[key] = []
            this.summaryAndDetailGoodsRel[key].push(item)
          }
          continue
        }
        const goods = sameGoods[key]
        // 计算汇总箱数和重量
        goods.boxesNumber += Number(item.boxesNumber)
        goods.weight += Number(item.weight)
        // 实际货物明细额外操作
        if (type === 'act') {
          if (item.palletUuid) {
            goods.palletContainerNum++
          } else {
            goods.otherContainerNum++
          }
          this.summaryAndDetailGoodsRel[key].push(item)
        }
        // 当前明细已存在汇总数据则比较并设置箱货编号起始和结束序号
        if (currentSeq < goods.beginSeq) {
          // 如果当前明细箱货编号作为起始编号则同时设置containerNo 方便最后生成汇总数据的箱货编号
          goods.beginSeq = currentSeq
          goods.containerNo = item.containerNo
        }
        if (currentSeq > goods.endSeq) {
          goods.endSeq = currentSeq
        }
      }
      // 生成汇总数据的箱货编号
      keys.forEach(key => {
        const goods = sameGoods[key]
        if (goods.beginSeq !== goods.endSeq && !isNaN(goods.beginSeq) && !isNaN(goods.endSeq)) {
          goods.containerNo = goods.containerNo + '-' + goods.endSeq
        }
        result.push(goods)
      })
      if (type === 'act') {
        this.summaryGoodsDetailList = result
      } else {
        this.summaryJobGoodsDetailList = result
      }
    },
    // 计算委托件毛体
    calcEstJmt() {
      // 委托
      this.form.quantityContract = 0
      this.form.weightContract = 0
      this.form.cubageContract = 0
      this.form.volumetricWeightContract = 0.0
      this.form.chargeWeightContract = 0.0
      const fbaJobGoods = this.form.fbaJobGoods || []
      if (fbaJobGoods && fbaJobGoods.length > 0) {
        let cubage = 0
        for (const item of fbaJobGoods) {
          if (item.boxesNumber) {
            this.form.quantityContract += Number(item.boxesNumber)
          }
          if (item.weight) {
            this.form.weightContract += Number(item.weight)
          }
          if (item.boxLength && item.boxWidth && item.boxHeight) {
            const tempCubage = Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight) * Number(item.boxesNumber)
            cubage += tempCubage
          }
        }
        this.form.cubageContract = (cubage / 1000000).toFixed(3)
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.form.chargingMethod) === 0) {
            this.form.volumetricWeightContract = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.form.volumetricWeightContract = (this.form.weightContract / 1000).toFixed(3)
          }
        }
        // 计费重量
        const params = {
          goods: this.form.fbaJobGoods,
          fbaQuotation: this.fbaQuotation,
          chargingMethod: this.form.chargingMethod,
          quantity: this.form.quantityContract,
          weight: this.form.weightContract,
          cubage: this.form.cubageContract,
          volumetricWeight: this.form.volumetricWeightContract
        }
        this.form.chargeWeightContract = FbaQuotationUtil.calChargeWeight(params)
      } else {
        if (this.form.jobInfo) {
          this.form.quantityContract = this.form.jobInfo.quantityContract
          this.form.weightContract = this.form.jobInfo.weightContract
          this.form.cubageContract = this.form.jobInfo.cubageContract
          if (this.form.seaJobInfo) {
            this.form.volumetricWeightContract = this.form.seaJobInfo.volumetricWeightContract
            this.form.chargeWeightContract = this.form.seaJobInfo.chargeWeightContract
          }
          if (this.form.airJobInfo) {
            this.form.volumetricWeightContract = this.form.airJobInfo.volumetricWeightContract
            this.form.chargeWeightContract = this.form.jobInfo.chargeWeight
          }
        }
      }
      this.form.weightContract = Number(this.form.weightContract).toFixed(2)
      this.form.cubageContract = Number(this.form.cubageContract).toFixed(3)
      this.form.volumetricWeightContract = Number(this.form.volumetricWeightContract).toFixed(3)
      this.form.chargeWeightContract = Number(this.form.chargeWeightContract).toFixed(3)
    },
    // 计算货物单箱材积和计费重量
    calcSingleVolumetricWeightAndChargeWeight(goods) {
      for (const item of goods) {
        let volumetricWeight = 0.0
        let chargeWeight = 0.0
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.form.chargingMethod) === 0) {
            volumetricWeight = ((Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight) * Number(item.boxesNumber)) / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            volumetricWeight = (item.singleBoxWeight / 1000).toFixed(3)
          }
        }
        // 计费重量
        const info = {
          goods: item,
          fbaChannel: this.fbaChannel,
          chargingMethod: this.form.chargingMethod,
          fbaQuotation: this.fbaQuotation,
          volumetricWeight: volumetricWeight,
          warehouseCode: this.form.warehouseCode
        }
        chargeWeight = FbaQuotationUtil.calSingleChargeWeight(info)
        item.volumetricWeight = volumetricWeight
        item.chargeWeight = chargeWeight
      }
      this.detailList.goodGridOptions.api.refreshCells({ force: true })
    },
    // 计算实际件毛体
    calcActJmt(init = false) {
      // 实际
      this.form.quantitySum = 0
      this.form.weightSum = 0
      this.form.cubageSum = 0
      this.form.volumetricWeightAct = 0.0
      let refreshCharge = false
      let chargeWeight = 0.0
      const warehouseInDetailList = this.form.warehouseInDetailList || []
      if (warehouseInDetailList && warehouseInDetailList.length > 0) {
        let cubage = 0
        for (const item of warehouseInDetailList) {
          if (item.boxesNumber) {
            this.form.quantitySum += Number(item.boxesNumber)
          }
          if (item.weight) {
            this.form.weightSum += Number(item.weight)
          }
          if (item.boxLength && item.boxWidth && item.boxHeight) {
            const tempCubage = Number(item.boxLength) * Number(item.boxWidth) * Number(item.boxHeight) * Number(item.boxesNumber)
            cubage += tempCubage
          }
        }
        this.form.cubageSum = (cubage / 1000000)
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.form.chargingMethod) === 0) {
            this.form.volumetricWeightAct = (cubage / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            this.form.volumetricWeightAct = (this.form.weightSum / 1000).toFixed(3)
          }
        }
        // 计费重量
        const params = {
          goods: this.form.warehouseInDetailList,
          fbaQuotation: this.fbaQuotation,
          chargingMethod: this.form.chargingMethod,
          quantity: this.form.quantitySum,
          weight: this.form.weightSum,
          cubage: this.form.cubageSum,
          volumetricWeight: this.form.volumetricWeightAct
        }
        chargeWeight = FbaQuotationUtil.calChargeWeight(params)
        refreshCharge = Number(Number(chargeWeight).toFixed(3)) !== Number(this.form.chargeWeightAct)
      }
      this.form.weightSum = Number(this.form.weightSum).toFixed(2)
      this.form.cubageSum = Number(this.form.cubageSum).toFixed(3)
      this.form.volumetricWeightAct = Number(this.form.volumetricWeightAct).toFixed(3)
      if (init && this.form.jobNo) {
        this.form.chargeWeightAct = Number(this.form.chargeWeightAct).toFixed(3)
      } else {
        this.form.chargeWeightAct = Number(chargeWeight).toFixed(3)
      }
      if (!init && refreshCharge && this.isEditing) {
        this.changeChargeWeight()
      }
    },
    async changeChargeWeight() {
      this.form.chargeWeightAct = Number(this.form.chargeWeightAct).toFixed(3)
      if (this.form.customerId && this.form.serviceChannel && this.form.chargeWeightAct && this.form.chargeWeightAct > 0) {
        await this.$confirm(this.$t('FbaJob.changeChargeWeight'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          // 刷新费用
          this.refreshCharge = true
        }).catch(() => {
          this.refreshCharge = false
        })
      }
    },
    chargeWeightActChange() {
      this.form.chargeWeightAct = Number(this.form.chargeWeightAct).toFixed(3)
    },
    getSubmitData(opType) {
      // 保存前校验
      if (!this.fbaLob) {
        this.validate(opType)
        this.checkSubmitData()
      }
      if (opType === 'weigh') {
        if (this.form.checklistTime || this.form.checklistStatus) {
          throw new TabError(this.$t('Warehouse.weightOpCannotChecklist'), 'baseInfo')
        }
      }
      this.form.lob = this.form.lob === 'FBA' ? '' : this.form.lob
      this.form.fba = true
      this.form.refreshCharge = this.refreshCharge
      this.form.branchId = this.$store.getters.currentOfficeId
      const fbaWarehouseInVO = { ...this.form }
      fbaWarehouseInVO.warehouseInDetail = []
      fbaWarehouseInVO.businessDocument = []
      const warehouseInDetailListForCheck = this.form.warehouseInDetailList
      let warehouseInDetailList = []
      if (opType === 'checklist') {
        this.form.warehouseInDetailList.forEach(e => {
          e.checklistTime = this.form.checklistTime
          e.checklistStatus = this.form.checklistStatus
          e.comments = this.form.comments
        })
        warehouseInDetailList = this.form.warehouseInDetailList
      } else {
        const updatedWarehouseInDetailList = this.form.warehouseInDetailList.filter(p => p.updated)
        warehouseInDetailList = [...updatedWarehouseInDetailList]
      }
      const updatedBusinessDocumentList = this.form.businessDocumentVOList.filter(p => p.updated)
      const businessDocumentVOList = [...updatedBusinessDocumentList]
      return {
        fbaWarehouseInVO: fbaWarehouseInVO,
        warehouseInDetailListForCheck,
        warehouseInDetailList,
        delWarehouseInDetailKeys: this.delWarehouseInDetailKeys,
        businessDocumentVOList,
        delBusinessDocumentKeys: this.delBusinessDocumentKeys
      }
    },
    // 保存前校验
    validate(opType) {
      // 入库时间、进仓编号、仓库名称必填
      const tabName = 'baseInfo'
      if (!this.form.warehouseNo) {
        throw new TabError(this.$t('Message.PleaseEnterTheWarehousingNumber'), tabName)
      }
      if (!this.form.warehouse) {
        throw new TabError(this.$t('Message.PleaseEnterTheWarehouseName'), tabName)
      }
      if (!this.form.warehouseInDate) {
        throw new TabError(this.$t('Message.PleaseEnterTheWarehouseInDate'), tabName)
      }
      // if (this.form.sealCargo && this.form.sealWeight === 0) {
      //   throw new TabError(this.$t('Message.PleaseSelectTheClosingWeight'), tabName)
      // }
      // if (this.form.weighTime) {
      //   if (!this.form.warehouseInDetailList || this.form.warehouseInDetailList.length <= 0) {
      //     throw new TabError(this.$t('Message.PleaseMaintainWeighDetail'), tabName)
      //   }
      // }
      // if (this.form.checklistTime) {
      //   if (!this.form.warehouseInDetailList || this.form.warehouseInDetailList.length <= 0) {
      //     throw new TabError(this.$t('Message.PleaseMaintainWeighDetail'), tabName)
      //   }
      //   if (!this.form.checklistStatus && this.form.checklistStatus !== 0) {
      //     this.form.checklistStatus = 1
      //   }
      //   if (this.form.checklistStatus != null && !this.form.checklistStatus) {
      //     if (!this.form.comments) {
      //       throw new TabError(this.$t('Message.PleaseEnterComments'), tabName)
      //     }
      //   }
      // }
      // if (this.form.packingTime) {
      //   if (!this.form.checklistTime) {
      //     this.context.loading.close()
      //     await this.$confirm(this.$t('Warehouse.continuePicking'), this.$t('Message.Tips'), {
      //       confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
      //       cancelButtonText: this.$t('CargoMsg.Cargo_No'),
      //       type: 'warning'
      //     }).then(() => {
      //       this.context.loading = getLoading()
      //     }).catch(() => {
      //       return Promise.reject(this.$t('Message.DeletionCancelled'))
      //     })
      //   }
      // }
      // if (this.form.returnGoodsTime) {
      //   this.context.loading.close()
      //   await this.$confirm(this.$t('Warehouse.continueReturnGoods'), this.$t('Message.Tips'), {
      //     confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
      //     cancelButtonText: this.$t('CargoMsg.Cargo_No'),
      //     type: 'warning'
      //   }).then(() => {
      //     this.context.loading = getLoading()
      //   }).catch(() => {
      //     return Promise.reject(this.$t('Message.DeletionCancelled'))
      //   })
      // }

      // 特殊保存
      if (!opType) return true
      if (opType === 'weigh') { // 称重
        if (!this.form.weighTime) {
          throw new TabError(this.$t('Warehouse.WeighTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'), tabName)
        }
      } else if (opType === 'checklist') { // 核单
        if (!this.form.checklistTime) {
          throw new TabError(this.$t('Warehouse.ChecklistTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'), tabName)
        }
        if (!this.form.checklistStatus && typeof this.form.checklistStatus !== 'number') {
          throw new TabError(this.$t('Warehouse.ChecklistResult') + this.$t('CargoMsg.Cargo_CanNotEmpty'), tabName)
        }
        if (this.form.checklistStatus === 0 && !this.form.comments) {
          throw new TabError(this.$t('Message.PleaseEnterComments'), tabName)
        }
        if (this.form.weighTime) {
          const weighTime = moment(this.form.weighTime).format('YYYY-MM-DD HH:mm')
          const checklistTime = moment(this.form.checklistTime).format('YYYY-MM-DD HH:mm')
          if (weighTime > checklistTime) {
            throw new TabError(this.$t('Warehouse.ChecklistTimeTip', [checklistTime, weighTime]), tabName)
          }
        }
      }

      // 称重、核单公共校验
      if (!this.form.warehouseInDetailList || this.form.warehouseInDetailList.length <= 0) {
        throw new TabError(this.$t('Warehouse.CargoDetails') + this.$t('CargoMsg.Cargo_CanNotEmpty'), tabName)
      }
      if (!this.form.quantitySum || Number(this.form.quantitySum) <= 0) {
        throw new TabError(this.$t('Warehouse.NumberOfCases') + this.$t('CargoMsg.Cargo_CanNotEmpty'), tabName)
      }
      if (!this.form.weightSum || Number(this.form.weightSum) <= 0) {
        throw new TabError(this.$t('Warehouse.Weight') + this.$t('CargoMsg.Cargo_CanNotEmpty'), tabName)
      }
      if (!this.form.cubageSum || Number(this.form.cubageSum) <= 0) {
        throw new TabError(this.$t('Warehouse.Volume') + this.$t('CargoMsg.Cargo_CanNotEmpty'), tabName)
      }
    },
    checkSubmitData() {
      for (const detail of this.form.warehouseInDetailList) {
        if (!detail.containerNo) {
          throw new TabError(this.$t('Warehouse.saveCheckContainerNoFail'), 'baseInfo')
        }
        if (!detail.shipmentId) {
          throw new TabError(this.$t('Warehouse.saveCheckShipmentIdFail'), 'baseInfo')
        }
        if (!detail.singleBoxWeight) {
          throw new TabError(this.$t('Warehouse.saveCheckQuantityFail'), 'baseInfo')
        }
        if (!detail.boxLength) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxLengthFail'), 'baseInfo')
        }
        if (!detail.boxWidth) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxWidthFail'), 'baseInfo')
        }
        if (!detail.boxHeight) {
          throw new TabError(this.$t('Warehouse.saveCheckBoxHeightFail'), 'baseInfo')
        }
        if (!detail.cargoChineseName) {
          throw new TabError(this.$t('Warehouse.saveCheckChineseCargoNameFail'), 'baseInfo')
        }
        if (!detail.cargoEnglishName) {
          throw new TabError(this.$t('Warehouse.saveCheckEnglishCargoNameFail'), 'baseInfo')
        }
      }
    },
    // 是否打托
    daycareInformationChangeHandler() {
      if (this.form.pallet && (!this.form.checklistStatus || Number(this.form.checklistStatus) !== 1)) {
        this.form.pallet = false
        this.$message.warning('订单未核单，请先进行核单操作。')
      }
      if (!this.form.pallet && this.form.fbaPallets && this.form.fbaPallets.length > 0) {
        this.form.pallet = true
        this.$message.warning('请先删除所有托盘。')
      }
    },
    checkboxChangeHandler() {
      if (!this.form.broken) {
        this.form.brokenQuantity = 0
      }
      if (!this.form.sealCargo) {
        this.form.sealWeight = 0
      }
    },
    // 加入货物
    addDetailHandler(estGoods) {
      const detail = new FbaWarehouseInDetail().fillDefaultValue().getData()
      if (estGoods) {
        estGoods.uuid = null
        Object.assign(detail, estGoods)
      }
      detail.warehouseInUuid = this.form.uuid
      detail.boxesNumber = 1
      detail.jobUuid = this.jobUuid
      detail.updated = true
      detail.tmpUuid = Math.random().toString(36).slice(3)
      this.form.updateCargoDetail = true
      this.form.warehouseInDetailList.push(detail)
      this.genSummaryGoodsDetailList()
      this.calcActJmt()
    },
    // 删除货物
    delDetailHandler() {
      this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = []
        const tmpUuids = []
        getGridSelected(this.detailList.goodGridOptions).forEach(rowData => {
          if (this.goodsViewSummary) {
            this.summaryAndDetailGoodsRel[rowData.key].forEach(detailGoods => {
              detailGoods.uuid ? uuids.push(detailGoods.uuid) : tmpUuids.push(detailGoods.tmpUuid)
            })
            const index = this.summaryGoodsDetailList.findIndex(item => item.key === rowData.key)
            if (index > -1) {
              this.summaryGoodsDetailList.splice(index, 1)
            }
          } else {
            rowData.uuid ? uuids.push(rowData.uuid) : tmpUuids.push(rowData.tmpUuid)
          }
        })
        this.deleteGoodsDetail(uuids)
        this.deleteTmpGoodsDetail(tmpUuids)
        this.calcActJmt()
        this.form.updateCargoDetail = true
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    // 删除已入库明细箱货信息
    deleteGoodsDetail(uuids) {
      for (const uuid of uuids) {
        if (uuid && !this.delWarehouseInDetailKeys.includes(uuid)) {
          this.delWarehouseInDetailKeys.push(uuid)
        }
        const index = this.form.warehouseInDetailList.findIndex(item => item.uuid === uuid)
        if (index > -1) {
          this.form.warehouseInDetailList.splice(index, 1)
        }
      }
      this.genSummaryGoodsDetailList()
    },
    // 删除临时明细箱货信息
    deleteTmpGoodsDetail(uuids) {
      for (const uuid of uuids) {
        const index = this.form.warehouseInDetailList.findIndex(item => item.tmpUuid === uuid)
        if (index > -1) {
          this.form.warehouseInDetailList.splice(index, 1)
        }
      }
      this.genSummaryGoodsDetailList()
    },
    // 删除文件
    delPhotoHandler() {
      if (this.photoListSelectedRow) {
        // 数据库删除使用
        const detailUuid = this.photoListSelectedRow.uuid
        if (detailUuid && !this.delBusinessDocumentKeys.includes(detailUuid)) {
          this.delBusinessDocumentKeys.push(detailUuid)
        }
        const index = this.photoList.gridOptions.selectedRowIndex
        if (index > -1) {
          this.form.businessDocumentVOList.splice(index, 1)
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
    },
    // 文件类型 编辑保存
    itemEditEndHandler(data) {
      if (data) {
        const list = []
        for (const p of this.form.businessDocumentVOList) {
          if (p.documentId === data.fileId) {
            p.fileCategory = data.fileCategory
            p.updated = true
          }
          list.push(p)
        }
        this.form.businessDocumentVOList = list
      }
    },
    // 检查委托和实际 箱数、单货箱重量、货箱长度、货箱宽度、货箱高度、托盘编号是否一致
    compareEstWarehouseInField(fieldName, current, targetList) {
      for (const e of targetList) {
        const sameItem = e.containerNo === current.containerNo
        if (sameItem) {
          let currentFieldValue = current[fieldName]
          let targetFieldValue = e[fieldName]
          if (fieldName === 'boxesNumber') {
            currentFieldValue = this.$numeral(currentFieldValue).format('0')
            targetFieldValue = this.$numeral(targetFieldValue).format('0')
          }
          if (fieldName === 'singleBoxWeight' || fieldName === 'boxLength' || fieldName === 'boxWidth' || fieldName === 'boxHeight' || fieldName === 'chargeWeight' || fieldName === 'volumetricWeight') {
            currentFieldValue = this.$numeral(currentFieldValue).format('0.000')
            targetFieldValue = this.$numeral(targetFieldValue).format('0.000')
          }
          if (targetFieldValue === currentFieldValue) {
            return { color: 'black' }
          }
        }
      }
      return { color: 'red' }
    },
    selectJobNoHandler(data) {
      if (!data) {
        return
      }
      this.form.flightAndTime = ''
      getFbaJobDetailByKey({ key: data }).then(async res => {
        if (res.data) {
          const overwrite = await this.confirmOverwriteWarehouseInDetail()
          if (overwrite) {
            this.clearJobData()
            this.jobKeyOld = this.form.jobKey
            this.oldWarehouseNo = this.form.warehouseNo
            this.form.jobKey = res.data['jobKey']
            this.bubbleCountingRatio = res.data['bubbleCountingRatio']
            Object.keys(this.form).forEach((key) => {
              if (key === 'warehouseInDetailList') {
                this.form.warehouseInDetailList = res.data['fbaWarehouseInDetailList']
                if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
                  this.form.warehouseInDetailList.forEach(e => {
                    e.warehouseInUuid = this.form.uuid
                    e.updated = true
                  })
                  this.form.checklistTime = this.form.warehouseInDetailList[0].checklistTime
                  this.form.checklistStatus = this.form.warehouseInDetailList[0].checklistStatus
                  this.form.comments = this.form.warehouseInDetailList[0].comments
                }
              } else if (res.data[key]) {
                this.form[key] = res.data[key]
              }
            })
            this.genSummaryGoodsDetailList()
            this.genSummaryJobGoodsDetailList()
            this.calcActJmt(true)
            if (this.form.fbaJobGoods && this.form.fbaJobGoods.length > 0) {
              this.calcEstJmt()
            } else {
              this.form.weightContract = this.form.weightContract.toFixed(2)
              this.form.cubageContract = this.form.cubageContract.toFixed(3)
              this.form.volumetricWeightContract = this.form.volumetricWeightContract.toFixed(3)
              this.form.chargeWeightContract = this.form.chargeWeightContract.toFixed(3)
            }
            this.form.flightAndTime = this.voyageFlightStr()
          } else {
            this.form.warehouseNo = this.oldWarehouseNo
          }
        } else {
          this.$message.warning(this.$t('Message.FailedPleaseRefreshAndAgain'))
        }
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 根据进仓编号获取业务
    warehouseNoChargeHandler(data) {
      setTimeout(() => {
        if (data === '') {
          return
        }
        this.loading = getLoading()
        this.filter.branchId = this.$store.getters.currentOfficeId
        this.filter.warehouseNo = this.form.warehouseNo
        this.filter.lob = this.lob
        getFbaJobByWarehouseNo(this.filter).then(async res => {
          this.loading.close()
          const j = res.data
          if (j === null || j.length === 0) {
            return
          }
          // 一个就直接用
          if (j.length === 1) {
            const overwrite = await this.confirmOverwriteWarehouseInDetail()
            if (overwrite) {
              this.clearJobData()
              this.jobKeyOld = this.form.jobKey
              this.oldWarehouseNo = this.form.warehouseNo
              this.form.jobKey = j[0]['jobKey']
              this.bubbleCountingRatio = j[0]['bubbleCountingRatio']
              Object.keys(this.form).forEach((key) => {
                if (key === 'warehouseInDetailList') {
                  this.form.warehouseInDetailList = j[0]['fbaWarehouseInDetailList']
                  if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
                    this.form.warehouseInDetailList.forEach(e => {
                      e.warehouseInUuid = this.form.uuid
                      e.updated = true
                    })
                    this.form.checklistTime = this.form.warehouseInDetailList[0].checklistTime
                    this.form.checklistStatus = this.form.warehouseInDetailList[0].checklistStatus
                    this.form.comments = this.form.warehouseInDetailList[0].comments
                  }
                } else if (j[0][key]) {
                  this.form[key] = j[0][key]
                }
              })
              this.genSummaryGoodsDetailList()
              this.genSummaryJobGoodsDetailList()
              this.calcActJmt(true)
              if (this.form.fbaJobGoods && this.form.fbaJobGoods.length > 0) {
                this.calcEstJmt()
              } else {
                this.form.weightContract = this.form.weightContract.toFixed(2)
                this.form.cubageContract = this.form.cubageContract.toFixed(3)
                this.form.volumetricWeightContract = this.form.volumetricWeightContract.toFixed(3)
                this.form.chargeWeightContract = this.form.chargeWeightContract.toFixed(3)
              }
              this.form.flightAndTime = this.voyageFlightStr()
            } else {
              this.form.warehouseNo = this.oldWarehouseNo
            }
          } else {
            // 多个选一下
            this.jobNosWindow.visible = true
            this.jobNosWindow.jobs = res.data
          }
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        })
      }, 100)
    },
    // 清理job相关数据
    clearJobData() {
      this.form.jobNo = ''
      this.form.etdString = ''
      this.form.loadingPortEnglish = ''
      this.form.mbl = ''
      this.form.carrierName = ''
      this.form.destinationPortEnglish = ''
      this.form.hbl = ''
      this.form.voyageFlight = ''
      this.form.customerName = ''
      this.form.quantityContract = 0
      this.form.weightContract = 0.00
      this.form.cubageContract = 0.000
      this.form.volumetricWeightContract = 0.000
      this.form.chargeWeightContract = 0.000
    },
    onSummaryContainerNoCellFocused(event) {
      if (event.column && event.column.colId === 'containerNo') {
        const data = this.detailList.goodGridOptions.api.getDisplayedRowAtIndex(event.rowIndex).data
        if (data !== null && this.isEditing) {
          if (!this.allowContainerNoCellEdit(data)) {
            return
          }
          this.containerNoEditor.shipmentId = data.shipmentId
          this.containerNoEditor.boxesNumber = data.boxesNumber
          this.containerNoEditor.visible = true
          this.containerNoEditor.key = data.key
          this.containerNoEditor.containerNo = data.containerNo
        }
      }
    },
    onDetailContainerNoCellFocused(event) {
      if (event.column && event.column.colId === 'containerNo') {
        const data = this.detailList.goodGridOptions.api.getDisplayedRowAtIndex(event.rowIndex).data
        if (data !== null && this.isEditing) {
          if (!this.allowContainerNoCellEdit(data)) {
            return
          }
          this.containerNoEditor.shipmentId = data.shipmentId
          this.containerNoEditor.visible = true
          this.containerNoEditor.key = data.uuid ? data.uuid : data.tmpUuid
          this.containerNoEditor.containerNo = data.containerNo
        }
      }
    },
    allowContainerNoCellEdit(data) {
      if (!data.shipmentId) {
        this.$message.warning(this.$t('Warehouse.shipmentIdNotNull'))
        return false
      }
      return true
    },
    onFileTypeCellFocused(event) {
      this.photoList.gridOptions.selectedRowIndex = event.rowIndex
      if (event.column && event.column && event.column.colId === 'fileCategory') {
        this.fileTypeEdit(this.form.businessDocumentVOList[event.rowIndex])
      }
    },
    fileTypeEdit(data) {
      if (data !== null && this.isEditing) {
        this.fileTypeEditor.fileId = data.documentId
        this.fileTypeEditor.fileCategory = data.fileCategory
        this.fileTypeEditor.visible = true
      }
    },
    suppressKeyboardEvent(param) {
      const currInput = param.event.target.attributes['data-index']
      if (currInput) {
        if (param.event.keyCode === 9 && currInput.value === 'sizeQuantity') {
          return false
        }
      }
      return true
    },
    // 批量维护
    batchMaintenance() {
      this.batchMaintenanceDialog.visible = true
    },
    // 批量导入
    batchImport() {

    },
    // 按客户数据拣货
    async pickingGoods() {
      if (this.form.fbaJobGoods && this.form.fbaJobGoods.length > 0) {
        if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
          await this.$confirm(this.$t('Warehouse.overwriteTheDetailRecord'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
            cancelButtonText: this.$t('CargoMsg.Cargo_No'),
            type: 'warning'
          }).then(() => {
            // 清空明细数据
            if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
              this.form.warehouseInDetailList.forEach(item => {
                this.delWarehouseInDetailKeys.push(item.uuid)
              })
              this.form.warehouseInDetailList = []
            }
            this.form.updateCargoDetail = true
            // 清空汇总数据
            this.summaryGoodsDetailList = []
          }).catch(() => {
            return Promise.reject(this.$t('Message.DeletionCancelled'))
          })
        }
        this.form.fbaJobGoods.forEach(goods => {
          this.addDetailHandler(goods)
        })
        this.detailList.goodGridOptionsEst.api.refreshCells({ force: true })
      }
    },
    // 关联业务确认覆盖实际货物信息
    async confirmOverwriteWarehouseInDetail() {
      let isOverwrite = false
      if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
        await this.$confirm(this.$t('Warehouse.overwriteTheDetailRecordByJobRelated'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          isOverwrite = true
          // 清空明细数据
          if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
            this.form.warehouseInDetailList.forEach(item => {
              this.delWarehouseInDetailKeys.push(item.uuid)
            })
            this.form.warehouseInDetailList = []
          }
          this.form.updateCargoDetail = true
          // 清空汇总数据
          this.summaryGoodsDetailList = []
        }).catch(() => {
        })
      } else {
        isOverwrite = true
      }
      return isOverwrite
    },
    // 调整计费重量
    adjustChargeWeight() {

    },
    // 清空
    clearData() {
      this.$confirm(this.$t('Warehouse.deleteTheDetailRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        type: 'warning'
      }).then(() => {
        // 清空明细数据
        if (this.form.warehouseInDetailList && this.form.warehouseInDetailList.length > 0) {
          this.form.warehouseInDetailList.forEach(item => {
            this.delWarehouseInDetailKeys.push(item.uuid)
          })
          this.form.warehouseInDetailList = []
        }
        this.form.updateCargoDetail = true
        // 清空汇总数据
        this.summaryGoodsDetailList = []
        this.form.quantitySum = 0
        this.form.weightSum = Number(0).toFixed(2)
        this.form.cubageSum = Number(0).toFixed(3)
        this.form.volumetricWeightAct = Number(0).toFixed(3)
        this.form.chargeWeightAct = Number(0).toFixed(3)
      }).catch(() => {
        return Promise.reject(this.$t('Message.DeletionCancelled'))
      })
    },
    // 列编辑
    async onCellChange(params) {
      this.form.updateCargoDetail = true
      const field = params.colDef.field
      const goods = params.data
      const internal = this.detailList.goodGridOptions.api.getSelectedRows()
      let volumetricWeight = 0.0
      let chargeWeight = 0.0
      if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
        // 材积
        if (this.bubbleCountingRatio > 0) {
          if (Number(this.form.chargingMethod) === 0) {
            volumetricWeight = ((Number(goods.boxLength) * Number(goods.boxWidth) * Number(goods.boxHeight) * Number(goods.boxesNumber)) / Number(this.bubbleCountingRatio)).toFixed(3)
          } else {
            volumetricWeight = (goods.singleBoxWeight / 1000).toFixed(3)
          }
        }
        // 计费重量
        const info = {
          goods: goods,
          fbaChannel: this.fbaChannel,
          chargingMethod: this.form.chargingMethod,
          fbaQuotation: this.fbaQuotation,
          volumetricWeight: volumetricWeight,
          warehouseCode: this.form.warehouseCode
        }
        chargeWeight = FbaQuotationUtil.calSingleChargeWeight(info)
      }
      if (this.goodsViewSummary) {
        // 编辑汇总数据 同步至本条汇总数据的所有明细数据
        const detailsOfSummaryGoods = this.summaryAndDetailGoodsRel[goods.key]
        detailsOfSummaryGoods.forEach(e => {
          if (field !== 'shipmentId' || !e.containerNo) {
            e[field] = goods[field]
          }
          if (field === 'singleBoxWeight') {
            e.weight = e.singleBoxWeight * e.boxesNumber
          }
          if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
            e.volumetricWeight = volumetricWeight
            e.chargeWeight = chargeWeight
          }
          e.updated = true
        })
        if (field === 'singleBoxWeight') {
          goods.weight = goods.singleBoxWeight * goods.boxesNumber
          this.detailList.goodGridOptions.api.updateRowData({ update: internal })
        }
        if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
          goods.volumetricWeight = volumetricWeight
          goods.chargeWeight = chargeWeight
          this.detailList.goodGridOptions.api.updateRowData({ update: internal })
        }
        if (field === 'shipmentId') {
          const containerNo = goods.containerNo
          if (containerNo) {
            await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              cancelButtonText: this.$t('CargoMsg.Cargo_No'),
              type: 'warning'
            }).then(() => {
              // 校验containerNo是否重复
              for (const detailGoods of detailsOfSummaryGoods) {
                const detailContainerNo = detailGoods.containerNo
                if (detailContainerNo) {
                  const newDetailContainerNo = detailContainerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                  if (this.containerNoDuplicate(newDetailContainerNo)) {
                    goods.shipmentId = params.oldValue
                    this.detailList.goodGridOptions.api.updateRowData({ update: internal })
                    return
                  }
                }
              }
              for (const detailGoods of detailsOfSummaryGoods) {
                const detailContainerNo = detailGoods.containerNo
                if (detailContainerNo) {
                  const newDetailContainerNo = detailContainerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
                  detailGoods.shipmentId = goods.shipmentId
                  detailGoods.containerNo = newDetailContainerNo
                }
              }
              goods.containerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
              this.detailList.goodGridOptions.api.updateRowData({ update: internal })
            }).catch(() => {
              goods.shipmentId = params.oldValue
              this.detailList.goodGridOptions.api.updateRowData({ update: internal })
              return Promise.reject(this.$t('Message.EditCancelled'))
            })
          }
        }
      } else {
        // 编辑单货箱重量同步重量
        if (field === 'singleBoxWeight') {
          goods.weight = goods.singleBoxWeight * goods.boxesNumber
          this.detailList.goodGridOptions.api.updateRowData({ update: internal })
        }
        // 编辑shipmentId刷新货箱编号
        if (field === 'shipmentId') {
          const containerNo = goods.containerNo
          if (containerNo) {
            await this.$confirm(this.$t('Warehouse.editShipmentId'), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              cancelButtonText: this.$t('CargoMsg.Cargo_No'),
              type: 'warning'
            }).then(() => {
              const newContainerNo = containerNo.replace(new RegExp(params.oldValue), goods.shipmentId)
              // 校验containerNo是否重复
              if (this.containerNoDuplicate(newContainerNo)) {
                goods.shipmentId = params.oldValue
                this.detailList.goodGridOptions.api.updateRowData({ update: internal })
                return
              }
              goods.containerNo = newContainerNo
              this.detailList.goodGridOptions.api.updateRowData({ update: internal })
            }).catch(() => {
              goods.shipmentId = params.oldValue
              this.detailList.goodGridOptions.api.updateRowData({ update: internal })
              return Promise.reject(this.$t('Message.EditCancelled'))
            })
          }
        }
        if (field === 'singleBoxWeight' || field === 'boxLength' || field === 'boxWidth' || field === 'boxHeight') {
          goods.volumetricWeight = volumetricWeight
          goods.chargeWeight = chargeWeight
          this.detailList.goodGridOptions.api.updateRowData({ update: internal })
        }
        goods.updated = true
        this.genSummaryGoodsDetailList()
      }
      this.calcActJmt()
    },
    // 核单
    onCheckList() {
      this.checklist.checklistTime = ''
      this.checklist.comments = ''
      this.checklist.checklistStatus = 1
      this.checklist.visible = true
    },
    // 确定核单
    toChecklist() {
      if (!this.checklist.checklistTime) {
        this.$message.warning(this.$t('Warehouse.ChecklistTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.checklist.checklistStatus && Number(this.checklist.checklistStatus) !== 0) {
        this.$message.warning(this.$t('Warehouse.ChecklistResult') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      if (!this.checklist.comments && Number(this.checklist.checklistStatus) === 0) {
        this.$message.warning(this.$t('Warehouse.HandlingOpinions') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return
      }
      const obj = {}
      obj.keys = [this.form.uuid]
      obj.anyStr = FbaJobConstants.WAREHOUSE_OP_CHECKLIST
      obj.anyDate = this.checklist.checklistTime
      obj.anyInteger = this.checklist.checklistStatus
      obj.anyStr1 = this.checklist.comments // 处理意见
      this.loading = getLoading()
      updateFields(obj).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Warehouse.Checklist') + this.$t('Message.Success'))
          this.form.checklistTime = this.checklist.checklistTime
          this.form.checklistStatus = this.checklist.checklistStatus
          this.form.comments = this.checklist.comments
        }
      }).finally(() => {
        this.checklist.visible = false
        this.loading.close()
      })
    },
    // 验证containerNo是否重复
    containerNoDuplicate(containerNo) {
      for (const detail of this.form.warehouseInDetailList) {
        if (containerNo === detail.containerNo) {
          this.$message.warning(StrUtils.substitute(this.$t('Warehouse.duplicateContainerNo'), containerNo))
          return true
        }
      }
      return false
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      // params.WAREHOUSE_UUID = [this.form.uuid]
      // params.USER_ID = this.$store.getters.userId
      PrintTemplateUtil.buildPrintDataByFbaInternalWarehouse(this.form, params)
      params.category = 'FBA_INTERNAL_WAREHOUSE'
      return params
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
.warehousing-detail {
  .custom-textarea {
    textarea {
      height: 64px;
    }
  }
  .blueStyle {
    color: $--color-primary-light-1;
  }
  .el-collapse {
    &-item {
      &__header {
        padding: 0 15px;
        border-bottom: none;
        color: #4283ff;
        font-weight: bold;
        background-color: #fff;
      }

      &__wrap {
        padding: 15px;
        border-bottom: none;
        background-color: #f0f3f8 !important;
      }

      &__arrow {
        color: #303133;
      }
    }
  }

  .spacing {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .grid-list {
    flex-direction: row;
    width: 80%;
    max-width: 950px;
    min-width: 950px;
  }

  .required .el-form-item__label {
    color: #1F75D5 !important
  }
}
</style>
